import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipCardComponent } from './payment-sip-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [PaymentSipCardComponent],
  exports: [PaymentSipCardComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskModule.forRoot()
  ]
})
export class PaymentSipCardModule { }
